import { GetStaticPropsContext } from 'next';

import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';
import { getPageTemplate } from '~/features/page-template/controllers/get-page-template';
import { AboutUs } from '~/features/page-template/templates/about-us/components/about-us';
import {
  AboutUsTemplate,
  aboutUsTemplateQuery,
  aboutUsTemplatesSchema,
} from '~/features/page-template/templates/about-us/model';

export default function AboutUsPage({ page, aboutUsTemplate }: { page: Page; aboutUsTemplate: AboutUsTemplate }) {
  return (
    <>
      <PageHead page={page} />
      <PageLayout withoutVerticalPadding>
        <AboutUs aboutUsTemplate={aboutUsTemplate} />
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  // Stop additional locale pages except the default locale from being built
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const [page, aboutUsTemplate] = await Promise.all([
    getPage('/about-us'),
    getPageTemplate<AboutUsTemplate>({
      templateName: 'About Us',
      templateQuery: aboutUsTemplateQuery,
      templateZodSchema: aboutUsTemplatesSchema,
    }),
  ]);

  return {
    props: {
      page,
      aboutUsTemplate,
    },
  };
}
